import React from "react";
import { Link as RouterLink } from "react-router-dom";
import { Breadcrumbs, Link, Stack, Typography } from "@mui/material";

import styles from "./styles";

interface BreadcrumbItem {
  label: string;
  path?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

const BreadcrumbComp: React.FC<BreadcrumbProps> = ({ items }) => {
  return (
    <Stack sx={styles.breadcrumb}>
      <Breadcrumbs
        aria-label="breadcrumb"
        separator=">"
        className="breadcrumbWrapper"
      >
        {items.map((item, index) =>
          item.path ? (
            <Link
              key={index}
              component={RouterLink}
              to={item.path}
              underline="hover"
              color="inherit"
            >
              {item.label}
            </Link>
          ) : (
            <Typography key={index} color="textPrimary">
              {item.label}
            </Typography>
          ),
        )}
      </Breadcrumbs>
    </Stack>
  );
};

export default BreadcrumbComp;
